// Layout.jsx – responsive shell, plain CSS only
import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const MECH_TABS = [
  { to: '/my-timesheet', label: 'My Timesheet' },
  { to: '/my-history',   label: 'History' },
];
const SUP_TABS = [
  { to: '/all-timesheets', label: 'All Timesheets' },
  { to: '/mechanics',      label: 'Mechanics' },
  { to: '/reports',        label: 'Reports' },
  { to: '/ip-management',  label: 'IP Management' },
];

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const tabs     = user?.role === 'mechanic' ? MECH_TABS : SUP_TABS;
  const initials = `${user?.first_name?.[0] || ''}${user?.last_name?.[0] || ''}`.toUpperCase();
  const isMech   = user?.role === 'mechanic';

  async function handleLogout() {
    await logout();
    navigate('/login');
  }

  return (
    <div className="app-shell">
      {/* ── Topbar ─────────────────────────────────────────── */}
      <header className="topbar">
        <div className="topbar-inner">
          {/* Brand */}
          <div className="brand">
            <div className="brand-icon">FC</div>
            <span className="brand-text">FMCC <span>TIMESHEET</span></span>
          </div>

          {/* Desktop user area */}
          <div className="topbar-user">
            <div className="flex items-center gap-2">
              <div className="user-avatar">{initials}</div>
              <div className="user-info">
                <div className="user-name">{user?.first_name} {user?.last_name}</div>
                <div className="user-meta">
                  <span className={`user-role-badge ${isMech ? 'mech' : 'super'}`}>
                    {user?.role?.toUpperCase()}
                  </span>
                  <span className="user-ee">#{user?.ee_number}</span>
                </div>
              </div>
            </div>
            <button className="logout-btn-top" onClick={handleLogout}>LOGOUT</button>
          </div>

          {/* Mobile hamburger */}
          <button
            className={`hamburger${menuOpen ? ' open' : ''}`}
            onClick={() => setMenuOpen(o => !o)}
            aria-label="Toggle menu"
          >
            <span /><span /><span />
          </button>
        </div>

        {/* Mobile dropdown */}
        <div className={`mobile-menu${menuOpen ? ' open' : ''}`}>
          <div className="mobile-user-row">
            <div className="user-avatar">{initials}</div>
            <div>
              <div className="user-name">{user?.first_name} {user?.last_name}</div>
              <div className="text-2xs text-muted">EE# {user?.ee_number} · {user?.role}</div>
            </div>
          </div>
          {tabs.map(t => (
            <NavLink key={t.to} to={t.to}
              onClick={() => setMenuOpen(false)}
              className={({ isActive }) => isActive ? 'active' : ''}>
              {t.label}
            </NavLink>
          ))}
          <button className="logout-btn nav-link-btn" onClick={handleLogout}>Logout</button>
        </div>
      </header>

      {/* ── Nav tabs ───────────────────────────────────────── */}
      <nav className="navbar">
        {tabs.map(t => (
          <NavLink key={t.to} to={t.to}
            className={({ isActive }) => isActive ? 'active' : ''}>
            {t.label}
          </NavLink>
        ))}
      </nav>

      {/* ── Page content ───────────────────────────────────── */}
      <main className="page-content">
        {children}
      </main>
    </div>
  );
}
